import { miniScanList } from '../contexts/MiniScanContext';
import * as theme from '../theme';

export default function MiniScansList() {

  const filteredScans = miniScanList
    .filter(scan => scan.label !== "No Preference")
    .sort((a, b) => a.label.localeCompare(b.label));

  return (
    <div style={{ ...theme.Container.flexColumn, flex: 2, gap: 20, marginTop: 10 }}>
      {filteredScans.map((scan, index) => (
        <div key={index} style={{ padding: '0px 10px' }}>
          <div style={{ fontWeight: 'bold', fontSize: 16 }}>{scan.label}</div>
          <div style={{ marginTop: 5, fontSize: 14, paddingBottom: 15, borderBottom: '1px solid #ccc' }}>{scan.description}</div>
        </div>
      ))}
    </div>
  );
}